"use client";

import { JobModal } from "@/features/settings/components/JobModal";
import { JobTable } from "@/features/settings/components/JobTable";
import { PageHeader } from "@/components/common/PageHeader";
import { Loading } from "@/components/ui/loading";
import {
  JobsManagementProvider,
  useJobsManagement
} from "@/components/common/JobsManagementBase";

function MyJobsContent() {
  const {
    jobs,
    loading,
    isJobModalOpen,
    selectedJob,
    setIsJobModalOpen,
    jobProfiles,
    companyId,
    fetchJobs,
    facilities
  } = useJobsManagement();

  if (loading) return <Loading text="Stellenangebote laden..." />;

  return (
    <div className="flex-1 flex flex-col overflow-hidden">
      <PageHeader
        breadcrumbs={[{ title: "Home", href: "/" }, { title: "Meine Jobs" }]}
      />
      <div className="p-6">
        <div className="space-y-2 mb-6">
          <div className="flex justify-between items-center">
            <div>
              <h1 className="text-2xl font-semibold">Meine Jobs</h1>
              <p className="text-gray-500">
                Verwalte die Stellenangebote deines Unternehmens.
              </p>
            </div>
          </div>
        </div>
        <JobTable jobs={jobs} />
        <JobModal
          open={isJobModalOpen}
          onOpenChange={setIsJobModalOpen}
          currentJob={selectedJob}
          title={selectedJob ? "Stelle bearbeiten" : "Neue Stelle hinzufügen"}
          jobProfiles={jobProfiles}
          companyId={companyId}
          onJobSaved={() => companyId && fetchJobs(companyId)}
          facilities={facilities}
        />
      </div>
    </div>
  );
}

export default function MyJobs() {
  return (
    <JobsManagementProvider>
      <MyJobsContent />
    </JobsManagementProvider>
  );
}
